(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-menu"] && !Shopify.designMode) return;
  try {
    
  const parents = document.querySelectorAll('.collection-menu .row');
  const parentsDropdown = document.querySelectorAll('.collection-menu .row .collection-menu-dropdown-inner');
  const wrappersDropdown = document.querySelectorAll('.collection-menu .row .collection-menu-dropdown');
  const menuLg = document.querySelector('.collection-menu .menu-lg');

  parents.forEach((item) => {
    const menuMd = menuLg.cloneNode(true);
    menuMd.classList.remove('menu-lg');
    menuMd.classList.add('menu-md');
    item.appendChild(menuMd);
  });

  parentsDropdown.forEach((item) => {
    const menuSm = menuLg.cloneNode(true);
    menuSm.classList.remove('menu-lg');
    menuSm.classList.add('menu-sm');
    item.appendChild(menuSm);
  });

  wrappersDropdown.forEach((item) => {
    const parentDropdown = item.querySelector('.collection-menu-dropdown-inner');
    const btn = item.querySelector('.title-button');
    const toggle = () => {
      parentDropdown.classList.toggle('is-active');
      btn.setAttribute('aria-expanded', btn.classList.toggle('is-active'));
    };
    btn.addEventListener('click', toggle);
    btn.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      toggle();
    });
  });

  (function () {
    let current = location.pathname.split('/')[2];
    if (current === '') return;
    let menuItems = document.querySelectorAll('.collection-menu-inner a.js-class');
    menuItems.forEach((item) => {
      if (item.getAttribute('href').includes(current)) {
        item.classList.add('is-active');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
